import { Filtration } from "../../shared/dataModels";

export class TransporterInfo {

    L: string;
    LastL: string;
    Cat: string;
    Mov: string;
    GSM: string;
    Sat: string;
    Batt: string;
    IsPanic: string;
    ODO: string;
    speed: string;
    temp: string;
    T: Date;
    Symbol: Symbol;
    SymbolPro: Symbol[];

}
export class TrackedObjectView {

    TrackedObjectId: number;
    TrackedObjectName: string;
    Date: Date;
    Speed: number;
    Temperature: number;
    Location: Location;
    LastLocation: Location;
    View: TransporterView;
    Icon: TransporterViewIcon;
    IsHiden: boolean = false;
    isfollowed: boolean = false;
    isselected: boolean = false;
}

export class Location {
    Latitude: number;
    Longitude: number;
}
export class TransporterView {
    Symbol: Symbol;
    SymbolProperties: Symbol[];
}

export class TransporterViewIcon {
    panic: string = "panic";
    unplugged: string = "unplugged";
    geofence: string = "geofence";
    speed: string = "speed";
    temprature: string = "temprature";
    signal: string = "signal";
    disconnected: string = "disconnected";
    carstatus: string = "idle";
}
export class TransporterBasicAvatar {

    SubId: number;
    TransporterId: number;
    DateTime: Date;
    FragmentNumber: number;
    TransporterInfo: TransporterInfo[] = [];
    returnTransporterInfo: TransporterInfo[] = [];
}
export class Symbol {

    UniqueName: string;
    LayerName: string;
    Properties: any;
}

export class EventLogBasic {

    SubId: number;
    VehicleId: number;
    DateTime: Date;
    Events: EventLog[] = [];
    EventTypeList: EventType[] = [];
    ComponentEventsList: ComponentEvents[] = [];
}
export class EventLog {

    EventID: number;
    EventType: string;
    Duration: number;
    StartDateTime: Date;
    EndDateTime: Date;
    StartLocation: string;
    EndLocation: string;
    EventTypeId: number;
    EventContinuityTypeId: number;
    EventValue: string;
    GeoFenceId: number;
    RuleId: number;
    BranchId: number;
    DriverId: number;
    WoId: number;
}

export class EventType {

    EventTypeId?: number;

    EventTypeName?: string;
    EventTypeSybmol?: string;
    EventContinuityTypeId?: number;
}

export class EventLayer {
    EventTypeID: string;
    Eventlayer: any;
    EventType: EventType;

    EventOverLayList: any[] = [];;
}

export enum MapEvents {
    Moving,


};

export class HistoryEventDetails {
    eventTypeId: number;
    title: string;
    startDate: string;
    endDate?: string;
    duration: number;
    location: string;
    address?: string;
}

export class ComponentEvents {
    Id: number;
    ComponentTypeID: number;
    EventTypeId: number;
    EventType: string;
    ContinuityTypeId: number;
    Value: string;
}

export class HistoryRouteSummary {
    ViolationsCount: number;
    ActiveTimeTotal: number;
    DistanceTotal: number;
    SpeedViolationCount: number
    TempuratureViolationCount: number;
    GeofenceViolationCount: number;
    MovingTimeTotal: number;
    IdleTimeTotal: number;
    FuelConsumptionTotal: number;
    ParkingTimeTotal: number;
    TripsCount: number
    ViolationTimeTotal: number;
    AvgSpeed: number;
    DisconnectedTimeTotal: number;
}

export class MonitorFilterModel {

    StartDateObj: Date;
    EndDateObj: Date;
    StartDate: string;
    EndDate: string;
    VehicleTypeIds: number[] = [];
    GroupIds: number[] = [];
    BrandIds: number[] = [];
    ModelIds: number[] = [];
    ManufacturerIds: number[] = [];
    BranchIds: number[] = [];
    IgnitionIds: number[] = [];
    VehicleStatus: string[] = [];
    SpeedStauts: string;
    SpeedNumber: number;
    NearestByDistance: number;
    NearestByLocations: Location[] = [];

    constructor(date?: Date) {
        if (date) {
            this.StartDateObj = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
            this.EndDateObj = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
        }

    }


}

export class MonitorFilteration {
    monitorFilters: MonitorFilterModel;
    Filters: Filtration;
}
export class Loc {
    monitorFilters: MonitorFilterModel;
    Filters: Filtration;
}

export enum EventTypeEnum {
    Moving = 1,
    Idle,
    Parking,
    Towing,
    Unplugged,
    PanicMoniter,
    SpeedMonitor,
    SpeedViolation,
    GeofenceInMonitor,
    GeofenceInViolation = 11,
    GeofenceOutViolation,
    DoorViolation = 14,
    SeatBeltViolation = 16,
    TemperatureViolation = 18,
    Disconnected,
    PanicViolation = 22
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/trackingAndMonitoring/dataModels/tracking.data-models.ts